import { __assign, __awaiter, __generator } from "tslib";
import { WidgetServices } from '../platform/platform-services';
import { WixOOISDKAdapter } from '@wix/bookings-adapter-ooi-wix-sdk';
import { WeeklyDayPickerViewModel } from './weekly-day-picker.view-model';
import * as moment from 'moment';
import { BookingsAPI } from '../api/bookingsAPI';
import { SlotsListViewModel } from './slots-list.view-model';
import { BiLogger } from '../bi-logger/bi-logger';
import { FedopsAdapter } from '@wix/bookings-adapters-reporting/dist/src/fedops/fedops-adapter';
import { WidgetName } from '../bi-logger/bi.const';
import DataPersister from '../utils/data-persister';
import { DAILY_TIMETABLE_WIDGET_ID } from '../platform/platform.const';
import Experiments from '@wix/wix-experiments';
import { getLocalTimezone } from '../utils/timezone';
import { DailyTimetableSettingsKeys, FirstDay, } from '@wix/bookings-app-builder-settings-const/dist/src/DailyTimeTable/Settings.const';
import { createSettings, getComponentSettings, } from '../app-settings/app-settings';
import { RefreshAppContextContextBuilder, } from '@wix/bookings-app-builder-settings-const/dist/src/DailyTimeTable/refresh-app-context';
import { isExperimentEnabled } from '../utils/experiment-enabled';
var DEFAULT_LANGUAGE = 'en';
var isSundayFirstDay = function (timetableConfig, translations) {
    return timetableConfig.firstDayOfWeek &&
        timetableConfig.firstDayOfWeek !== FirstDay.NONE
        ? timetableConfig.firstDayOfWeek === FirstDay.SUNDAY
        : translations['first-day-of-week.in-english'] === 'Sunday';
};
var isTextDefinedInSettings = function (settings, key) {
    return settings[key] !== undefined;
};
var getSessionsForDate = function (date, slotsListViewModel, httpAdapter, businessTimezone, localTimezone, regionalSettings) { return __awaiter(void 0, void 0, void 0, function () {
    var sessionsInRange;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, slotsListViewModel.setLoading()];
            case 1:
                _a.sent();
                return [4 /*yield*/, httpAdapter.getSessionsForDate({
                        date: date,
                        timezone: localTimezone,
                        regionalSettings: regionalSettings,
                    })];
            case 2:
                sessionsInRange = _a.sent();
                return [2 /*return*/, sessionsInRange.slots];
        }
    });
}); };
var getTimetableConfig = function (wixSdkAdapter, httpAdapter, businessTimezone, localTimezone, regionalSettings, externalId, appDefId) { return __awaiter(void 0, void 0, void 0, function () {
    var settings;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!wixSdkAdapter.isSSR()) return [3 /*break*/, 2];
                settings = createSettings({
                    appDefId: appDefId,
                    externalId: externalId,
                    wixSdkAdapter: wixSdkAdapter,
                });
                _a = {
                    slots: [],
                    firstDateWithSessions: moment().format('YYYY-MM-DD')
                };
                return [4 /*yield*/, getComponentSettings(settings)];
            case 1: return [2 /*return*/, (_a.settings = _b.sent(),
                    _a)];
            case 2: return [2 /*return*/, httpAdapter.getTimetableConfig({
                    timezone: localTimezone,
                    regionalSettings: regionalSettings,
                })];
        }
    });
}); };
var dataPersister = new DataPersister();
var experiments = new Experiments({ scope: 'bookings-viewer-script' });
function setUpTimeTable(appParams, $w, $widget, config, wixSdkAdapter, fedopsAdapter, refreshAppContext, externalId) {
    return __awaiter(this, void 0, void 0, function () {
        var isDisplayBookButtonOnTTEnabled, isExpandAllElementsOnCSR, isTimetableAccessibilityEnabled, biLogger, httpAdapter, businessTimezone, localTimezone, language, failedTranslationFetch, regionalSettings, _a, timetableConfig, translations, e_1, slotsListViewModel, selectedDate, sundayAsFirstDay, onDaySelected, getTranslation, dayPickerViewModel, setSessions;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, isExperimentEnabled('specs.bookingsViewerScript.DisplayBookButtonOnTT', experiments)];
                case 1:
                    isDisplayBookButtonOnTTEnabled = _b.sent();
                    return [4 /*yield*/, isExperimentEnabled('specs.bookings.ExpandAllTimeTableElementsOnCsr', experiments)];
                case 2:
                    isExpandAllElementsOnCSR = _b.sent();
                    return [4 /*yield*/, isExperimentEnabled('specs.bookings.TimetableAccessibility', experiments)];
                case 3:
                    isTimetableAccessibilityEnabled = _b.sent();
                    biLogger = new BiLogger(wixSdkAdapter, WidgetName.DAILY_TIMETABLE);
                    httpAdapter = new BookingsAPI(appParams.instance, wixSdkAdapter, externalId);
                    businessTimezone = wixSdkAdapter.getSiteTimezone() || 'UTC';
                    localTimezone = getLocalTimezone(businessTimezone);
                    language = wixSdkAdapter.getCurrentLanguage();
                    failedTranslationFetch = false;
                    regionalSettings = wixSdkAdapter.getRegionalSettings();
                    if (!wixSdkAdapter.isEditorMode() && !wixSdkAdapter.isPreviewMode()) {
                        fedopsAdapter.logInteractionStarted('get-tt-data');
                    }
                    return [4 /*yield*/, Promise.all([
                            dataPersister.getOrFetch(function () {
                                return getTimetableConfig(wixSdkAdapter, httpAdapter, businessTimezone, localTimezone, regionalSettings, externalId, appParams.appDefinitionId);
                            }, refreshAppContext.shouldFetchServices),
                            dataPersister.getOrFetch(function () {
                                return httpAdapter
                                    .getTranslations(language)
                                    .catch(function () {
                                    return httpAdapter
                                        .getTranslations(language)
                                        .catch(function () { return (failedTranslationFetch = true); });
                                });
                            }, refreshAppContext.shouldFetchServices),
                        ])];
                case 4:
                    _a = _b.sent(), timetableConfig = _a[0], translations = _a[1];
                    if (!wixSdkAdapter.isEditorMode() && !wixSdkAdapter.isPreviewMode()) {
                        fedopsAdapter.logInteractionEnded('get-tt-data');
                    }
                    if (!failedTranslationFetch) return [3 /*break*/, 8];
                    wixSdkAdapter.setCurrentLanguage(DEFAULT_LANGUAGE);
                    language = wixSdkAdapter.getCurrentLanguage();
                    _b.label = 5;
                case 5:
                    _b.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, httpAdapter.getTranslations(language)];
                case 6:
                    translations = _b.sent();
                    return [3 /*break*/, 8];
                case 7:
                    e_1 = _b.sent();
                    console.error("Failed to get translations for default language - " + language + ": " + e_1.message);
                    return [3 /*break*/, 8];
                case 8:
                    timetableConfig.settings = __assign(__assign({}, timetableConfig.settings), refreshAppContext.updatedSettings);
                    if (isTextDefinedInSettings(timetableConfig.settings, DailyTimetableSettingsKeys.TIMETABLE_HEADING_TEXT)) {
                        $w('#timetableTitle').text =
                            timetableConfig.settings[DailyTimetableSettingsKeys.TIMETABLE_HEADING_TEXT] || translations['bookings.daily-timetable.title'];
                    }
                    if (isTextDefinedInSettings(timetableConfig.settings, DailyTimetableSettingsKeys.EMPTY_STATE_TEXT)) {
                        $w('#messageText').text =
                            timetableConfig.settings[DailyTimetableSettingsKeys.EMPTY_STATE_TEXT] ||
                                translations['bookings.daily-timetable.empty-state'];
                    }
                    slotsListViewModel = new SlotsListViewModel({
                        $w: $w,
                        $widget: $widget,
                        wixSdkAdapter: wixSdkAdapter,
                        biLogger: biLogger,
                        bookingsApi: httpAdapter,
                        isDisplayBookButtonOnTTEnabled: isDisplayBookButtonOnTTEnabled,
                        timetableSettings: timetableConfig.settings,
                    });
                    selectedDate = moment(timetableConfig.firstDateWithSessions);
                    sundayAsFirstDay = isSundayFirstDay(timetableConfig, translations);
                    onDaySelected = function (date, range, navigationInfo) { return __awaiter(_this, void 0, void 0, function () {
                        var newSessions;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, getSessionsForDate(date, slotsListViewModel, httpAdapter, businessTimezone, localTimezone, regionalSettings)];
                                case 1:
                                    newSessions = _a.sent();
                                    biLogger.sendTimetableNavigationEvent(__assign(__assign({}, navigationInfo), { additionalInfo: date.toISOString(), isEmptyState: newSessions.length === 0 }));
                                    return [2 /*return*/, setSessions(newSessions, isTimetableAccessibilityEnabled)];
                            }
                        });
                    }); };
                    getTranslation = function (key) { return translations[key]; };
                    dayPickerViewModel = new WeeklyDayPickerViewModel({
                        $widget: $widget,
                        $w: $w,
                        wixSdkAdapter: wixSdkAdapter,
                        getTranslation: getTranslation,
                        onDaySelected: onDaySelected,
                        sundayAsFirstDay: sundayAsFirstDay,
                    });
                    setSessions = function (newSessions, shouldFocusFirstItem) {
                        if (shouldFocusFirstItem === void 0) { shouldFocusFirstItem = false; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                return [2 /*return*/, slotsListViewModel.setSlotsList(newSessions, translations, businessTimezone, shouldFocusFirstItem)];
                            });
                        });
                    };
                    // Leave SSR in loading state so it shows with loader and SSR cache is meaningful
                    if (wixSdkAdapter.isSSR()) {
                        slotsListViewModel.setCleanMode();
                        dayPickerViewModel.hideAllElements();
                    }
                    else {
                        setSessions(timetableConfig.slots).catch(function (e) {
                            return console.error('Failed to set sessions - ', e);
                        });
                        dayPickerViewModel.setSelectedDate(selectedDate);
                        if (isExpandAllElementsOnCSR) {
                            // Show hidden elements when not in SSR (we must hide them in SSR since data is dynamic) #SCHED-19226
                            dayPickerViewModel.hideAllElements();
                            dayPickerViewModel.showAllElements();
                        }
                    }
                    dayPickerViewModel.setViewLoaded();
                    slotsListViewModel.setViewLoaded();
                    if (!dataPersister.get("APP_LOADED_LOGGED" /* APP_LOADED_LOGGED */)) {
                        fedopsAdapter.logAppLoaded();
                        biLogger.sendTimetableLoadedEvent({
                            additionalInfo: selectedDate.toISOString(),
                            isEmptyState: timetableConfig.slots.length === 0,
                        });
                        dataPersister.set("APP_LOADED_LOGGED" /* APP_LOADED_LOGGED */, true);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function createRefreshAppContext(_a) {
    var refreshAppInput = _a.refreshAppInput, isPreviewMode = _a.isPreviewMode;
    var refreshAppContext;
    if (typeof refreshAppInput === 'object' && refreshAppInput) {
        refreshAppContext = refreshAppInput;
    }
    else {
        var refreshAppContextContextBuilder = new RefreshAppContextContextBuilder();
        if (refreshAppInput) {
            refreshAppContextContextBuilder.shouldFetchServices();
        }
        else {
            refreshAppContextContextBuilder.shouldNotFetchServices();
        }
        refreshAppContext = refreshAppContextContextBuilder.build();
    }
    // need to investigate - when switching to preview mode in editor, the loader will get stuck, adding 'isPreviewMode' solves it (talk to Or if not sure)
    if (isPreviewMode) {
        refreshAppContext.shouldFetchServices = true;
    }
    return refreshAppContext;
}
export var createWidgetController = function (_a) {
    var compId = _a.compId, type = _a.type, config = _a.config, $w = _a.$w, warmupData = _a.warmupData, setProps = _a.setProps, appParams = _a.appParams, platformAPIs = _a.platformAPIs, wixCodeApi = _a.wixCodeApi, livePreviewOptions = _a.livePreviewOptions, externalId = _a.externalId;
    return __awaiter(void 0, void 0, void 0, function () {
        var wixSdkAdapter, fedopsAdapter, widgetProps, widgetServices, $widget, initialControllerAPI, onPropsChanged, shouldFetchData, refreshAppContext;
        return __generator(this, function (_b) {
            wixSdkAdapter = new WixOOISDKAdapter(wixCodeApi, platformAPIs, appParams, compId);
            fedopsAdapter = new FedopsAdapter(wixSdkAdapter, DAILY_TIMETABLE_WIDGET_ID);
            widgetProps = {};
            widgetServices = new WidgetServices(widgetProps);
            $widget = widgetServices.get$widget($w);
            initialControllerAPI = {};
            onPropsChanged = function (oldProps, newProps) { };
            $widget.onPropsChanged(onPropsChanged);
            shouldFetchData = livePreviewOptions && livePreviewOptions.shouldFetchData;
            refreshAppContext = createRefreshAppContext({
                refreshAppInput: shouldFetchData,
                isPreviewMode: wixSdkAdapter.isPreviewMode(),
            });
            return [2 /*return*/, {
                    pageReady: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var pageReadyPromise;
                        return __generator(this, function (_a) {
                            pageReadyPromise = setUpTimeTable(appParams, $w, $widget, config, wixSdkAdapter, fedopsAdapter, refreshAppContext, externalId);
                            return [2 /*return*/, pageReadyPromise];
                        });
                    }); },
                    exports: function () {
                        return widgetServices.generateControllerAPI($widget, initialControllerAPI);
                    },
                }];
        });
    });
};
//# sourceMappingURL=daily-timetable.controller.js.map